import React from 'react'
import { createRoot } from 'react-dom/client'
import { ApolloProvider, useMutation } from '@apollo/client'
import sendOnboardingEmail from '../mutations/send-onboarding-email'
import client from '../client'

function OnboardingLink({ id: id }) {
  const [message, setMessage] = React.useState('Send On-Boarding Email')
  const [recipient, setRecipient] = React.useState('')
  const [disabled, setDisabled] = React.useState(true)
  const [sendOnboardingEmailMutation] = useMutation(sendOnboardingEmail)

  const handleSendOnboardingEmail = (e) => {
    e.preventDefault()

    sendOnboardingEmailMutation({ variables: { id, recipient } }).then(
      (org) => {
        setMessage('Email sent')
        setDisabled(true)
        setRecipient('')
      }
    )
  }

  const handleRecipientInput = (e) => {
    setRecipient(e.currentTarget.value)
    if (recipient.length > 5) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }

  return (
    <div style={{ marginBottom: '40px' }}>
      <input
        type="text"
        placeholder="Onboarding recipient"
        onChange={handleRecipientInput}
        value={recipient}
      />
      <button disabled={disabled} onClick={handleSendOnboardingEmail}>
        {message}
      </button>
    </div>
  )
}

const onboardingLink = document.getElementById('onboarding-link')
if (onboardingLink) {
  const id = onboardingLink.getAttribute('data-id')
  const props = { id }

  const root = createRoot(onboardingLink)
  root.render(
    <ApolloProvider client={client}>
      <OnboardingLink {...props} />
    </ApolloProvider>
  )
}
